export class Mp4ConvertionProgress {
  constructor(public percentage: number, public fileId: string, public fileName: string = '') {}
}
